"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Refreshoff: function() {
        return Refreshoff;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const Refreshoff = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsxs)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M21 8L18.74 5.74C16.931 3.99122 14.516 3.00947 12 3C11 3 10.03 3.16 9.13 3.47M8 16H3V21M3 12C3 9.51 4 7.26 5.64 5.64",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
        }),
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M3 16L5.26 18.26C7.06897 20.0088 9.48395 20.9905 12 21C14.49 21 16.74 20 18.36 18.36M21 12C21 13 20.84 13.97 20.53 14.87M21 3V8H16M22 22L2 2",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
        })
    ]
}), "Refreshoff");
const _default = Refreshoff;
